






































import {
  Component,
  Vue,
  Prop,
  Provide,
  Watch,
  Model
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import Loader from "@/components/Loader.vue";
import TemplateTable from "@/components/contentset/manager/TemplateTable.vue";
import MultivariateSettings from "@/components/contentset/manager/MultivariateSettings.vue";
import ContentTemplateEditor from "@/components/contentset/manager/ContentTemplateEditor.vue";
import { IContentSetVersion } from "../../../models/interfaces/content/content-set-version.model.interface";
import { ContentSetVersionModel } from "../../../models/content/content-set-version.model";
import { IContentTemplate } from "../../../models/interfaces/content/content-template.model.interface";
import { ContentTemplateModel } from "../../../models/content/content-template.model";
import ValidationService from "../../../services/validation.service";
import VeeValidate from "vee-validate";
import container from "../../../inversify.config";

const ContentSetVersionModule = namespace("contentSetVersionModule");

@Component({
  components: {
    Loader,
    TemplateTable,
    MultivariateSettings,
    ContentTemplateEditor
  }
})
export default class ConfigureContent extends Vue {
  @ContentSetVersionModule.Action public retrieveConfigurationVersion;
  @ContentSetVersionModule.Action public createConfiguration;
  @ContentSetVersionModule.Getter public configuration;

  get getContentSetVersionModel(): IContentSetVersion {
    return this.configuration;
  }

  get contentSetVersionValid(): boolean {
    if (
      this.contentSetVersion === null ||
      typeof this.contentSetVersion === "undefined" ||
      this.contentSetVersion.contentSetVersionId < 1
    ) {
      return false;
    }

    return true;
  }

  private loading: boolean = true;

  private contentSetVersion: IContentSetVersion = new ContentSetVersionModel();

  private template: IContentTemplate = new ContentTemplateModel();

  private contentSetName: string = "";

  private showContentEditor: boolean = false;

  @Watch("getContentSetVersionModel", { deep: true })
  public onContentSetUpdate() {
    this.contentSetVersion = this.getContentSetVersionModel;
  }

  public getValidationClass(fieldName: string) {
    return container
      .get<ValidationService>(ValidationService)
      .getValidationClass(this.$validator, fieldName);
  }

  public updateTemplateModalState(templateModalState: boolean) {
    this.showContentEditor = templateModalState;
  }

  public created() {
    this.getConfigureContentSetVersion();
  }

  private getConfigureContentSetVersion() {
    this.loading = true;
    this.retrieveConfigurationVersion().then((result) => {
      this.loading = false;
      if (this.getContentSetVersionModel) {
        this.contentSetVersion = this.getContentSetVersionModel;
      }
    });
  }

  private addTemplate() {
    this.showContentEditor = true;
  }

  private submitForm() {
    this.$validator.validateAll().then((valid) => {
      if (valid) {
        this.createConfiguration(this.contentSetName);
      }
    });
  }
}
